<!--
  功能：可开票订单列表
  作者：Maoxiangdong
  邮箱：862755519@qq.com
  时间：2022年07月18日 08:55:02
-->
<template>
<div class="page-container">
    <div>
        <van-tabs v-model="active" sticky color="#FF7307" @click="tabChange" class="tabs-container">
            <!-- 网约车列表 -->
            <van-tab title="网约车">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoadMore">
                    <div class="no-img" v-if="onlineInvoiceData.length == 0">
                        <img src="https://img01.yzcdn.cn/vant/empty-image-default.png" />
                    </div>

                    <div class="order-card" v-else v-for="item in onlineInvoiceData" :key="item.id" @click="showData(item.id)">
                        <div class="order-row">
                            <span class="order-name">{{ item.name }}</span>
                            <span class="order-state" v-if="item.invoiceStatus == 'ISSUED'">已开具</span>
                            <span class="order-state" v-if="item.invoiceStatus == 'REVERSED'">已冲红</span>
                            <span class="order-state" v-if="item.invoiceStatus == 'REOPEN'">已重开</span>
                        </div>
                        <div class="order-center">

                            <div class="item-tel" style="margin-top:0px;">发票金额：<span style="color:red;">{{ (parseInt(item.amount) * 0.01).toFixed(2) }}</span> 元</div>
                            <div class="item-tel">发票内容：{{ item.content }}</div>
                            <div class="item-tel">发票类型：<span style="color:#FF7307">{{ item.titleType == 0 ? '企业公司' : '个人/非企业' }}</span></div>
                            <div class="item-tel">开票时间：{{ item.applyTime }}</div>
                            <div class="item-tel">{{item.titleType == 0 ? '公司税号' : '身份证号'}}：{{ item.taxNumber }}</div>
                            <div class="item-tel">{{item.titleType == 0 ? '公司电话' : '联系号码'}}：{{ item.mobile }}</div>
                            <div class="item-tel">邮箱：{{ item.email }}</div>
                            <div class="item-tel">备注信息：{{ item.remark }}</div>
                        </div>
                    </div>
                </van-list>
            </van-tab>
            <!-- 拼团车列表 -->
            <van-tab title="拼团车">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoadMore">
                    <div class="no-img" v-if="groupInvoiceData.length == 0">
                        <img src="https://img01.yzcdn.cn/vant/empty-image-default.png" />
                    </div>
                    <div class="order-card" v-else v-for="item in groupInvoiceData" :key="item.invoiceRecordEntity.id" @click="showData(item.invoiceRecordEntity.id)">
                        <div class="order-row">
                            <span class="order-name">{{ item.invoiceRecordEntity.name }}</span>
                            <span class="order-state" v-if="item.invoiceRecordEntity.invoiceStatus == 'ISSUED'">已开具</span>
                            <span class="order-state" v-if="item.invoiceRecordEntity.invoiceStatus == 'REVERSED'">已冲红</span>
                            <span class="order-state" v-if="item.invoiceRecordEntity.invoiceStatus == 'REOPEN'">已重开</span>
                        </div>
                        <div class="order-center">
                            <div class="item-tel" style="margin-top:0px;">发票金额：<span style="color:red;">{{ (parseInt(item.invoiceRecordEntity.amount) * 0.01).toFixed(2) }}</span> 元</div>
                            <div class="item-tel">发票内容：{{ item.invoiceRecordEntity.content }}</div>
                            <div class="item-tel">发票类型：<span style="color:#FF7307">{{ item.invoiceRecordEntity.titleType == 0 ? '企业公司' : '个人/非企业' }}</span></div>
                            <div class="item-tel">开票时间：{{ item.invoiceRecordEntity.applyTime }}</div>
                            <div class="item-tel">{{item.invoiceRecordEntity.titleType == 0 ? '公司税号' : '身份证号'}}：{{ item.invoiceRecordEntity.taxNumber }}</div>
                            <div class="item-tel">{{item.invoiceRecordEntity.titleType == 0 ? '公司电话' : '联系号码'}}：{{ item.invoiceRecordEntity.mobile }}</div>
                            <div class="item-tel">邮箱：{{ item.invoiceRecordEntity.email }}</div>
                            <div class="item-tel">备注信息：{{ item.invoiceRecordEntity.remark }}</div>
                        </div>
                    </div>
                </van-list>
            </van-tab>
        </van-tabs>
    </div>
</div>
</template>

<script>
import {
    getWycInvoiceList,
    getPtcInvoiceList
} from 'api/invoice'
export default {
    // 组件名称
    name: 'BillRecord',
    // 组件参数 接收来自父组件的数据
    props: {},
    // 局部注册的组件
    components: {},
    // 组件状态值
    data() {
        return {
            active: 0, //标签下标
            loading: false, //加载更多
            finished: false, //加载更多
            onlineInvoiceData: [], //发票列表
            groupInvoiceData: [], //发票列表
            param: {
                current: 0,
                size: 10
            }
        }
    },
    // 计算属性
    computed: {

    },
    // 侦听器
    watch: {},
    // 组件方法
    methods: {
        showData(event) {
            this.$router.push({
                name: 'InvoiceDetail',
                query: {
                    id: event,
                  invoiceType: this.active
                }
            })
        },
        //加载更多
        onLoadMore() {
            console.log('加载更多')
            if (this.active == 0) {
                this.param.current++
                this.getWycList()
            }
            if (this.active == 1) {
                this.param.current++
                this.getPtcList()
            }
        },
        // 切换tab
        tabChange(event) {
            this.initData();
            // if (event == 0) {
            //     this.getWycList()
            // }
            // if (event == 1) {
            //     this.getPtcList()
            // }
        },
        //初始化数据
        initData() {
            this.loading = false, //加载更多
                this.finished = false, //加载更多
                this.onlineInvoiceData = [], //发票列表
                this.groupInvoiceData = [], //发票列表
                this.param = {
                    current: 0,
                    size: 10
                }
        },
        // 获取网约车开票列表
        getWycList() {
            let param = this.param
            getWycInvoiceList(param).then((res) => {
                this.loading = false
                if (res) {
                    if (res.records.length < this.param.size) {
                        console.log('没有更多了')
                        this.finished = true
                    }
                    this.onlineInvoiceData.push.apply(this.onlineInvoiceData, res.records)
                }
            })
        },
        //获取拼团车开票列表
        getPtcList() {
            let param = this.param
            getPtcInvoiceList(param).then((res) => {
                this.loading = false
                if (res) {
                    if (res.records.length < this.param.size) {
                        console.log('没有更多了')
                        this.finished = true
                    }
                    this.groupInvoiceData.push.apply(this.groupInvoiceData, res.records)
                }
            })
        }
    },
    //在实例初始化之后，组件属性计算之前，如data属性等
    beforeCreate() {},
    //组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
    created() {},
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() {},
    //挂载后
    mounted() {},
    //数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
    beforeUpdate() {},
    //数据更新时后调用
    updated() {},
    // keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
    activated() {},
    // keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
    deactivated() {},
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() {},
    //Vue 实例销毁后调用。
    destroyed() {}
}
</script>

<style lang="scss" scoped>
.no-img {
    text-align: center;
    padding-top: 100px;
    color: rgb(180, 178, 178);
    font-size: 14px;
    font-weight: 400;

    img {
        width: 200px;
        height: auto;
        margin-bottom: 20px;
    }
}

.tabs-container {
    padding-bottom: 100px;
}

.order-address {
    width: 91%;
}

.order-center {
    padding: 15px;
}

.order-text {
    padding: 20px;
    text-align: center;
    font-size: 14px;
    color: #999;
}

.order-card {
    width: 94%;
    margin: auto;
    margin-top: 12px;
    height: auto;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 0px 3px 0px rgba(185, 184, 184, 0.1);

    .order-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 15px;
        border-bottom: 1px solid #f5f7f9;
    }

    .order-name {
        color: #999;
        font-size: 18px;
        font-weight: 500;
        color: #17233d;
    }

    .order-state {
        font-size: 12px;
        padding: 2px 8px;
        background-color: #f5f7f9;
        color: #888;
        border-radius: 2px;
    }

    .item-tag {
        font-size: 13px;
        color: #ff7307;
        background-color: rgba(255, 115, 8, 0.1);
        padding: 3px 10px;
        font-weight: 400;
        border-radius: 3px;
        margin-right: 6px;
    }

    .item-tel {
        margin-top: 8px;
        color: #515a6e;
        font-size: 14px;
    }

}
</style>
